import { render, staticRenderFns } from "./AddAssessmentBatch.vue?vue&type=template&id=215bed35"
import script from "./AddAssessmentBatch.vue?vue&type=script&lang=js"
export * from "./AddAssessmentBatch.vue?vue&type=script&lang=js"
import style0 from "./AddAssessmentBatch.vue?vue&type=style&index=0&id=215bed35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports